import React, { useContext, useEffect } from 'react';

import { Spin } from 'antd';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { get, set } from '@src/packages/utils/storage';
import languageData from '@src/containers/Topbar/languageData';

import Error404 from '../Error404';
import TimeTracker from './TimeTracker';
import Portal from './Main/screens/Portal';
import { AUTH_DT_ROUTES } from './constants';
import { AuthDtRoutes } from './Auth/AuthDtRoutes';
import { AuthContext } from './contexts/AuthProvider';
import OptionPickerView from './Main/screens/OptionPickerView/screens/OptionPickerView';
import SessionClosedModal from './components/SessionClosedModal';
import useDtCrossTabSessionClosed from './hooks/useDtCrossTabSessionClosed';

function TimeTrackerApp() {
  const location = useLocation();
  const { user, loading } = useContext(AuthContext);
  const { showSessionClosedModal, onAcceptSessionClosed } = useDtCrossTabSessionClosed();
  const isLogged = user !== null && !loading;

  // We are gonna force to change the language to spanish
  useEffect(() => {
    const locale = get('locale');
    if (locale && locale?.locale === 'es') return;

    if (location.pathname === '/dt/options') {
      set('locale', { ...languageData.find(l => l.locale === 'es') });
      window.location.reload();
    }
  }, []);

  if (loading) {
    return (
      <>
        <SessionClosedModal open={showSessionClosedModal} onAccept={onAcceptSessionClosed} />
        <Spin />
      </>
    );
  }

  return (
    <>
      <SessionClosedModal open={showSessionClosedModal} onAccept={onAcceptSessionClosed} />
      <Switch>
      {!isLogged && <Route path="/dt/options" component={OptionPickerView} />}
      {isLogged && <Route path="/dt/options" component={OptionPickerView} />}
      {!isLogged && <Route path="/dt" component={AuthDtRoutes} />}
      {isLogged && <Redirect exact from={AUTH_DT_ROUTES.SIGN_IN} to="/dt" />}
      {isLogged && <Redirect exact from={AUTH_DT_ROUTES.ENTER_PASSWORD} to="/dt" />}

      {isLogged && <Route exact path="/dt" component={Portal} />}

      {isLogged && <Route path="/dt/:orgId?" component={TimeTracker} />}

      <Route component={Error404} />
      </Switch>
    </>
  );
}

export default TimeTrackerApp;
